/** FIDE titles a user can apply for (nextjs#1058). */
export const FIDE_TITLES = [
    "GM",
    "IM",
    "FM",
    "CM",
    "WGM",
    "WIM",
    "WFM",
    "WCM",
] as const;

export type FideTitle = (typeof FIDE_TITLES)[number];

export function isFideTitle(value: unknown): value is FideTitle {
    return (
        typeof value === "string" && (FIDE_TITLES as readonly string[]).includes(value)
    );
}
